<template>

    <b-table v-bind="tableAttributes" :fields="fields" :items="items">
        <template #cell(name)="data">
            {{ data.item.name }}
        </template>

        <template #cell(code)="data">
            {{ data.item.code }}
        </template>

        <template #cell(HowManyCanBeUsed)="data">
            <span class="text-wrap">{{ formatNumber(data.item.HowManyCanBeUsed) }}</span>
        </template>

        <template #cell(price)="data">
            {{ formatNumber(data.item.price) }}
        </template>

        <template #cell(active_at)="data">
            {{ convertToJalali(data.item.active_at) }}
        </template>

        <template #cell(expire_at)="data">
            {{ convertToJalali(data.item.expire_at) }}
        </template>

        <template #cell(action)="data">
            <div v-if="(data.item.deleted_at == null)">
                <span
                    class="h5"
                    v-if="isDeletable(data.item)"
                    @click="deleteFunction(data.item)"
                    v-b-tooltip.hover
                    title="حذف">
                    <b-icon icon="trash"></b-icon>
                </span>

                <span class="h5" v-b-tooltip.hover title="ویرایش">
                    <router-link
                        :to="{ name: 'UpdateOffer', params: { id: data.item.id } }">
                        <b-icon icon="pencil" class="mr-3"></b-icon>
                    </router-link>
                </span>
            </div>

            <div v-else>
                <span 
                    class="h5" 
                    v-b-tooltip.hover title="حذف دائمی"
                    v-if="isDeletable(data.item)">                                
                    <b-icon icon="trash" @click="forceDeleteFunction(data.item)"></b-icon>
                </span>

                <span class="h5" v-b-tooltip.hover title="بازگردانی">
                    <b-icon
                        icon="arrow-clockwise"
                        class="mr-3"
                        @click="restoreFunction(data.item)">
                    </b-icon>
                </span>
            </div>
        </template>
    </b-table>
</template>

<script>
import {mapActions} from "vuex";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import { formatNumber } from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {convertToJalali} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
    name: 'OfferItems',
    props: ['items'],
    data() {
        return {
            tableAttributes,
            fields: [
                {key: "name", label: "نام"},
                {key: "code", label: "کد"},
                {key: "HowManyCanBeUsed", label: "تعداد موجودی"},
                {key: "price", label: "قیمت"},
                {key: "active_at", label: "تاریخ فعال شدن"},
                {key: "expire_at", label: "تاریخ انقضا"},
                {key: "action", label: "عملیات"},
            ],
        }
    },
    methods: {
        convertToJalali,
        formatNumber,
        ...mapActions({
            deleteOffer: "Offer/deleteOffer",
            forceDeleteOffer: "Offer/forceDeleteOffer",
            restoreOffer: "Offer/restoreOffer",
        }),
        deleteFunction(item) {
            if (confirm('آیا از حذف این تخفیف اطمینان دارید؟')) {
                this.deleteOffer(item);
            }
        },
        forceDeleteFunction(item) {
            if (confirm('آیا از حذف این تخفیف اطمینان دارید؟')) {
                this.forceDeleteOffer(item);
            }
        },
        restoreFunction(item) {
            if (confirm('آیا از بازیابی این تخفیف اطمینان دارید؟')) {
                this.restoreOffer(item);
            }
        },
        isDeletable(item) {
            return true;
        },
    }
}
</script>

<style scoped>
    .text-wrap {
        word-wrap: break-word;
    }
</style>